import { AsyncPipe } from "@angular/common";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { FieldType, FormlyModule } from "@ngx-formly/core";
import { FormlySelectModule, FormlySelectOption } from "@ngx-formly/core/select";
import { Message } from "primeng/message";
import { NewUiMultiselectComponent } from "../../shared/form/multiselect/new-ui-multiselect.component";
import { NewUiFormElementMapModule } from "../../shared/from-element-map/new-ui-form-element-map.module";
import { TestIdDirective } from "../../shared/test-id/test-id.directive";
import { GroupItemsPipe } from "./group-items.pipe";

@Component({
  selector: "new-ui-formly-multiselect",
  templateUrl: "./new-ui-formly-multiselect.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    NewUiFormElementMapModule,
    TestIdDirective,
    FormlyModule,
    AsyncPipe,
    FormlySelectModule,
    GroupItemsPipe,
    Message,
    NewUiMultiselectComponent,
  ],
})
export class NewUiFormlyMultiSelectComponent extends FieldType {
  getText(value: string[], options: FormlySelectOption[]): string {
    if (value != null && Array.isArray(value)) {
      return (options ?? [])
        .filter((x) => value.includes(x.value))
        .map((y) => y.label)
        ?.join(", ");
    } else {
      return "";
    }
  }
}
